import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InfiniteScroll from 'react-infinite-scroller';
import { Loader } from 'components/loaders';
export const InfiniteScroller = ({ children, isFetching, onLoadMore, hasMore, }) => (_jsxs(InfiniteScroll, { pageStart: 0, hasMore: hasMore, initialLoad: false, loadMore: onLoadMore, children: [children, isFetching && _jsx(Loader, {})] }));
